import {
  parse as p,
  ASTNode,
  ObjectTypeDefinitionNode,
  Kind,
  InterfaceTypeDefinitionNode,
  DefinitionNode,
  visit,
  buildASTSchema,
  DocumentNode,
  buildSchema,
  buildClientSchema,
  TypeNode,
  FieldDefinitionNode,
  NamedTypeNode,
  EnumTypeDefinitionNode,
  printSchema,
  GraphQLSchema,
  print,
  Source,
  TypeDefinitionNode,
} from "graphql";

import * as gt from "graphql-typed";
import { mergeTypeDefs } from "@graphql-tools/merge";

import {
  cleanDocument,
  toSimpleDocument,
  extractImports as exImports,
} from "graphql-mini-transforms";

export function parse(sdl: string) {
  return p(sdl);
}

export function clean(document: DocumentNode) {
  return cleanDocument(document);
}

export function extractImports(sdl: string) {
  return exImports(sdl);
}

const hasDirective = (directiveName: string) => (
  typeObj: TypeDefinitionNode
): boolean => {
  if (typeObj && typeObj.directives && typeObj.directives.length) {
    return (
      typeObj.directives.find((d) => d.name.value === directiveName) !==
      undefined
    );
  }
  return false;
};

type SchemaRepresentations = string | GraphQLSchema | DocumentNode | Source;

export function mergeTypes(sdl: string[]) {
  return mergeTypeDefs(sdl);
}
